export const getOrder = (
  name: string,
  sub_filters: Array<{ name: string }>
) => {
  const filterObj: any = sub_filters?.find((obj) => obj.name === name);
  return sub_filters.indexOf(filterObj);
};

export const hasAllFilters = (
  filterNames: any,
  sub_filters: Array<{ name: string }>
) =>
  filterNames?.every((name: string) =>
    sub_filters?.some((obj: any) => obj.name === name)
  );

export const extractKeyValuePairs = (
  obj: Record<string, any>,
  keys: string[]
) => {
  const result: Record<string, any> = {};
  keys.forEach((key) => {
    if (typeof obj !== "undefined" && key in obj) {
      result[key] = obj[key];
    }
  });
  return result;
};
